import { componentByKey, currentStageLabel } from "./byceEvidencePresentation";

const number = (evidence, key) => componentByKey(evidence, key)?.value || 0;
const date = value => value ? new Date(value).toLocaleDateString() : "—";
const stage4Status = value => ({ not_started: "Not started", in_progress: "In progress", completed: "Completed", completed_results_pending: "Completed — results pending", completed_results_released: "Completed — results released" }[value] || "Not started");
const displayPoints = value => Number.isInteger(value) ? String(value) : Number(value).toFixed(1);

export const projectG3ParticipantSummary = ({ progress, evidence }) => Object.freeze({
  currentStage: currentStageLabel(progress),
  listeningSessions: `${number(evidence, "completed-listening-sessions")} of 13`,
  reflections: `${number(evidence, "completed-reflections")} of 4`,
  stage4: stage4Status(componentByKey(evidence, "stage-4-execution")?.value),
  grade: (() => {
    const adjusted = componentByKey(evidence, "adjusted-grade-points")?.value;
    const base = componentByKey(evidence, "base-grade-points")?.value;
    const active = componentByKey(evidence, "engagement-adjustment-active")?.value === "active";
    if (active && Number.isFinite(adjusted)) return `${displayPoints(adjusted)} / 40 (adjusted)`;
    return Number.isFinite(base) ? `${displayPoints(base)} / 40` : "—";
  })(),
  recentActivity: date(progress?.currentAttempt?.lastActivityAt),
});
